export default {
  login: {
    title: 'Translation......',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    useridplaceholder: 'Please Input Username',
    passwordplaceholder: 'Please Input Password',
    lineidplaceholder: 'Please Select LineId',
    factoryIdAndLineidVerify: 'Lineid must be chosed',
    useridlength: 'Translation......',
    passwordlength: 'Translation......',
    copyright: 'Translation......'
  },
  request: {
    title: 'Translation......',
    confirmtext: 'Relogin',
    canceltext: 'Cancle',
    interface404: 'Translation......',
    interface504: 'Translation......',
    sessionExpired: 'No operation for a long time，Please checkin again'
  },
  general: {
    downtime: 'down Time',
    AnalysisofCp: 'Analysis of Cp',
    ProductionStatistics: 'Production Statistics',
    cancelReceive: 'Cancel Receive',
    tountil: 'TO',
    produceNum: 'Produce Number',
    taskstatusquery: 'Task status query',
    taskclosedstatusquery: 'Close the task status query',
    close: 'Mission off',
    deselect: 'Deselect',
    rise: 'Sort Rise',
    decline: 'Sort Decline',
    issued: 'Mission Issued',
    freeze: 'Mission Freeze ',
    prompt: 'Prompt',
    search: 'Search',
    uploadPhoto: 'Upload Photo',
    reUpdate: 'Re-update',
    viewImage: 'View Image',
    deleteImage: 'Delete Image',
    create: 'Create',
    delete: 'Delete',
    refresh: 'Refresh',
    modify: 'Modify',
    config: 'Config',
    sure: 'Sure',
    cancel: 'Cancle',
    receive: 'Receive',
    operation: 'Operation',
    submit: 'Submit',
    goBack: 'Return',
    isdisabled: 'Is Disabled Or Not',
    grid: 'Data Grid',
    password: 'Password',
    factoryId: 'Factory ID',
    factoryName: 'Factory Name',
    lineId: 'Line ID',
    lineName: 'Line Name',
    assemblyLineId: 'AssemblyLine ID',
    assemblyLineName: 'AssemblyLine Name',
    postionConfig: 'Postion Config',
    postionName: 'Postion Name',
    factoryassemblyholder: 'Please Select Follow Infomation',
    subassemblylineid: 'Sub Assembly Line Id',
    subassemblylinename: 'Sub Assembly Line Name',
    subassemblylinenameplaceholder: 'Please Select A SubassemblyLine',
    opid: 'OP ID',
    opname: 'OP Name',
    positionselect: 'Please Select Operation Position',
    programid: 'Program',
    programname: 'Program Name',
    productmodel: 'Product Model',
    producttypeid: 'ProductType ID',
    productmodelname: 'Product Model Name',
    actionid: 'Action ID',
    actionname: 'Action Name',
    stepid: 'Step ID',
    stepname: 'Step Name',
    ordernumber: 'Order Number',
    serialNumber: 'Serial Number',
    serialNumberplaceholder: 'Please Input Serial Number',
    serialNumberNotNull: 'Serial Number IS Not Null',
    configured: 'Configured',
    notconfigured: 'Not Configured',
    forbidden: 'Forbidden',
    notforbidden: 'NOT Forbidden',
    attention: 'Attention',
    deleteattention: 'This Delete Operation Will Also Delete Every Correlation Between This Item And Other Data',
    deleteConfirm: 'This operation permanently deletes the data. Do you want to continue?',
    receiveConfirm: 'This operation permanently receive this ERP order. Do you want to continue??',
    lengthplaceholder: 'Input Content Is TOO LONG',
    numberholder: 'Please Input A Number',
    productmixplaceholder: 'Please Input Letter OR Number Under 20 Character',
    numberorword: 'Please input numbers or letters',
    keyword: 'Please Input A Keyword',
    selectproduct: 'Select',
    mainline: 'Main Assembly Line',
    updateUserId: 'Update UserID',
    reseiveSuccess: 'Reseive Success',
    updateUserName: 'Update UserName',
    updateDate: 'Update Date',
    insertUserId: 'Insert UserID',
    insertUserName: 'Insert UserName',
    insertDate: 'Insert Date',
    productIdAreaMin: 'Serial Number Area Begin',
    productIdAreaMax: 'Serial Number Area End',
    productIdAreaPlaceholder: 'Please Input Serial Number',
    factoryIdPlaceholder: 'Please Input Factory Code',
    lineIdPlaceholder: 'Please Input Line Code',
    opCodePlaceholder: 'Please Input Op Code ',
    opCodeenter: 'Please Choose Op Code',
    errString: 'No special characters are supported',
    maxLength5: 'Please Input A Number Less Than 6 Digits',
    rangLength0_20: 'Please Input A Number 0~5 Digits',
    maxLength1: 'Please Input A Number 0~9 Digits',
    maxLength10: 'Please Input A Number Less Than 10 Digits',
    maxLength20: 'Please Input A Number Less Than 20 Digits',
    maxLength30: 'Please Input A Number Less Than 30 Digits',
    maxLength50: 'Please Input A Number Less Than 50 Digits',
    maintainIdPlaceholder: 'Please Enter Maintenance Plan Number',
    factoryIdNotNull: 'Factory ID Is Mandatory',
    lineIdNotNull: 'Line ID Is Mandatory',
    factoryNameNotNull: 'Factory Name Is Mandatory',
    lineNameNotNull: 'Line Name Is Mandatory',
    orderNumberNotNull: 'ERP Order Number Is Required ',
    planformNotNull: 'Plan Form Id Is Required',
    enginetypelittlenotNull: 'Engine Type Little Is Required',
    enginetypenotNull: 'Engine Type Is Required',
    ordercountnotNull: 'Order Count Is Required',
    opNumNotNull: 'OpNum Is Required',
    opNameNotNull: 'OpName Is Required',
    andonCodeNotNull: 'amlamp type code cannot be empty ',
    andonContentNotNull: 'amlamp type description cannot be empty ',
    programNumNotNull: 'program number cannot be empty ',
    remarkNotNull: 'remark not null',
    remarkPlaceholder: 'please enter remark',
    engineTypePlaceholder: 'please enter machine number ',
    engineTypeLittlePlaceholder: 'please enter the model number',
    platformIdPlaceholder: 'please enter the platform number',
    maintainIdNotNull: 'Maintenance Plan Number Is Required',
    maintainIdExisted: 'Maintenance Plan Is Already Existed',
    version: 'Version',
    newSuccess: 'Add Success',
    updateSuccess: 'Update Success',
    deleteSuccess: 'Delete Success',
    deleteFailed: 'Delete Fail',
    cancelDelete: 'Cancel Delete',
    chooseData: 'Please Select a Data',
    disableorenable: 'Disable Or Enable',
    ERPordernum: 'ERP Order Number',
    producedate: 'Produce Date',
    shift: 'Shift Code',
    offline: 'Offline Count',
    online: 'Online Count',
    okcount: 'OK Count',
    ngcount: 'NG Count',
    dateend: 'End Time',
    platform: 'Platform ID',
    datetime: 'Please Select Date ',
    timeFormatterWraning: 'Time format error',
    timeFormatterWraning1: 'The rest time is greater than the time difference between the end of the shift and the beginning of the shift, please choose the time again',
    all: 'All',
    yes: 'yes',
    no: 'no',
    noResponseWarningMessage: 'no conforms to the data query condition',
    downloading: 'downloading',
    downloadingWarning: 'Export failure',
    line: 'line',
    bar: 'bar',
    pie: 'pie',
    maxValue: 'maxValue',
    minValue: 'minValue',
    avgValue: 'avgValue',
    maxPoint: 'maxPoint',
    minPoint: 'minPoint',
    timeValueWarningMessage: 'please enter time query conditions ',
    placeholderStart: 'start time',
    rangeSeparatoe: 'to',
    placeholderEnd: 'end time',
    timeValueOnLine: 'online time area',
    timeValueOffLine: 'offline time area',
    pickerOptionsShortcutsText1: 'in the latest week',
    pickerOptionsShortcutsText2: 'the last month',
    pickerOptionsShortcutsText3: 'in the past three months',
    on: 'start',
    off: 'close',
    resetPassword: 'Password reset successful',
    selectFactoryId: 'Please select factory ID',
    factoryNamePlaceholder: 'Please select factory',
    lineNamePlaceholder: 'Please select line',
    particular: 'particular',
    showMore: 'MORE',
    alldata: 'all data',
    platformId: 'platform id',
    confirmUpdate: 'Confirm Update',
    updateattention: 'Update Attention',
    cancelUpdate: 'Cancel Update',
    station: 'station'
  },
  AlarmHistory: {
    title: 'Equipment Alarm Inquiry',
    alarmTypeCode: 'Alarm Type Code',
    alarmTypeName: 'Alarm Type Name',
    alarmLevel: 'Alarm Level',
    callTime: 'Call Time',
    resetTime: 'Reset Time',
    lastTime: 'Last Time',
    productIdPlaceholder: 'Please Input Produce ID',
    productId: 'Produce ID'

  },
  MacMachAlarm: {
    title: 'Alarm Info Config',
    listTitle: 'Alarm Info Config List',
    factoryId: 'workplace number ',
    factoryName: 'workstation name ',
    lineId: 'body number ',
    lineName: 'line body name ',
    placeholderFactoryId: 'please enter workplace name ',
    placeholderLineId: 'please enter line body name ',
    alarmNum: 'Alarm Code',
    alarmLevel: 'Alarm Level',
    alarmText: 'Alarm Text',
    alarmAddRule: 'Alarm Address',
    supplierNum: 'Supplier Code',
    supplierNam: 'Supplier Name',
    isDisable: 'Is Disable',
    alarmNumPlaceholder: 'Please Input Alarm Code',
    alarmLevelPlaceholder: 'Please Input Alarm Level',
    alarmTextPlaceholder: 'Please Input Alarm Text',
    alarmAddRulePlaceholder: 'Please Input Alarm Address',
    supplierNumPlaceholder: 'Please Input Supplier Code',
    supplierNamPlaceholder: 'Please Input Supplier Name',
    digitlengthplaceholder6: 'Please Input A Number Less Than 6 Digits',
    alarmNumNotNull: 'Alarm Code Is Mandatory',
    alarmLevelNotNull: 'Alarm Level Is Mandatory',
    alarmTextlNotNull: 'Alarm Text Is Mandatory',
    alarmAddRuleNotNull: 'Alarm Address Is Mandatory',
    supplierNumNotNull: 'Supplier Code Is Mandatory',
    supplierNamlNotNull: 'Supplier Name Is Mandatory',
    disableValue1: 1, // 禁用
    inDisableValue1: 0, // 未禁用
    disableText1: 'Yes',
    inDisableText1: 'No'
  },
  MacMachAlarmOp: {
    title: 'AlarmDetail',
    listTitle: 'AlarmDetailTable',
    comboxOpId: 'Please select op',
    alarmDetailNum: 'Alarm Detail Code',
    supplierNum: 'Supplier Code',
    opId: 'OP Id',
    alarmLevel: 'Alarm Level',
    alarmText: 'Alarm Text',
    alarmAdd: 'Alarm Address',
    factoryIdPlaceholder: 'Please Input Factory Code',
    lineIdPlaceholder: 'Please Input Line Code',
    alarmDetailNumPlaceholder: 'Please Input Alarm Detail Code',
    supplierNumPlaceholder: 'Please Input supplier Code',
    opIdPlaceholder: 'Please Input OP ID',
    alarmLevelPlaceholder: 'Please Input Alarm Level',
    alarmTextPlaceholder: 'Please Input Alarm Text',
    alarmAddPlaceholder: 'Please Input Alarm Address',
    digitlengthplaceholder6: 'Please Input A Number Less Than 6 Digits',
    alarmDetailNumNotNull: 'Alarm Detail Code Is Mandatory',
    supplierNumNotNull: 'Supplier Code Is Mandatory',
    opIdNotNull: 'OP ID Is Mandatory',
    alarmLevelNotNull: 'Alarm Level Is Mandatory',
    alarmTextlNotNull: 'Alarm Text Is Mandatory',
    alarmAddRuleNotNull: 'Alarm Address Is Mandatory'
  },
  CraDisposalType: {
    title: 'Disposal class dictionary',
    type: 'type',
    judgeType: 'Determine the category',
    disposalMethod: 'disposal method',
    validateType: 'type is empty',
    validateJudgeType: 'Determine the category is empty',
    validateMethod: 'disposal method is empty'
  },
  MachiningStatistics: {
    title1: 'Unqualified parts input',
    title2: 'Unqualified parts inquiry',
    title3: 'Record missing parts',
    title4: 'Check missing parts',
    title5: 'Qualified rate query',
    title6: 'Entry of qualified parts',
    title7: 'Qualified parts inquiry',
    frameNumber: 'Baskets of no.',
    save: 'save',
    partNumber: ' Part number',
    manufacturer: 'Blank manufacturer',
    mouldNumber: 'mould number',
    batchNumber: 'batch number',
    judgeType: 'Determine the category',
    disposalMethod: 'disposal method',
    number: 'No.',
    frameNumberValidate: 'Baskets of no. is empty',
    partNumberValidate: 'Part number is empty',
    manufacturerValidate: 'Blank manufacturer is empty',
    mouldNumberValidate: 'mould number is empty',
    batchNumberValidate: 'batch number is empty',
    judgeTypeValidate: 'Determine the category is empty',
    disposalMethodValidate: 'disposal method is empty',
    isEmpty: 'row is empty',
    updateDate: 'update date',
    type: 'type',
    leaveTime: 'leave time',
    backTime: 'back time',
    testNumber: 'test times',
    timeEmpty: 'time is empty',
    timeTypeEmpty: 'type or time is empty',
    timeIsEmpty: 'time is empty',
    parts: 'parts already exist in the pass or fail table'
  },
  PerShift: {
    title: 'Supervise the shift',
    factoryId: 'Factory Name',
    lineId: 'Line Name',
    workShiftId: 'Shift Id',
    workShiftName: 'Shift Name',
    workShiftStartTime: 'Shift StartTime',
    workShiftEndTime: 'Shift EndTime',
    workShiftWorkTime: 'Shift Time',
    pworkShiftStartTime: 'Please Select Shift StartTime',
    pworkShiftEndTime: 'Please Select Shift EndTime',
    nworkShiftId: 'Shift Id can not be Empty',
    nworkShiftName: 'Shift Name can not be Empty',
    nworkShiftStartTime: 'Start Time can not be Empty',
    nworkShiftEndTime: 'End Time can not be Empty',
    pfactoryId: 'Please Input Factory Name',
    plineId: 'Please Input Line Name',
    pworkShiftId: 'Please Input Shift Id',
    pworkShiftName: 'Please Input Shift Name',
    ptimeOutStart: 'Please Input Break Start Time',
    ptimeOutEnd: 'Please Input Break End Time',
    ptimeOut: 'Please Input BreakTime',
    timeOut: 'BreakTime',
    workShiftOrder: 'Work Shift Order',
    showBreakTimeList: 'Show BreakTime List',
    timeOutNumber: 'TimeOut Times',
    timeOutStartTime: 'Break Start Time',
    timeOutEndTime: 'Break End Time',
    addTimeOut: 'Add Break Time',
    breakTime: 'BreakTime',
    pworkShiftOrder: 'Please Input Work Shift Order',
    updateUserName: 'update UserName',
    No: 'No',
    shift: 'Shift',
    workShiftTimeOver24Hours: 'WorkShiftTime Over 24 Hours，Please Enter Again',
    setBreakTimeDuringWorkShiftTime: 'Please Enter BreakTime Between WorkShiftTime',
    enterLastShiftOfBreakEndTIme: 'Please Enter Last Shift Of BreakEndTime',
    enterBreakTimeOutsideLastShiftOfBreakEndTIme: 'Please Enter BreakTime Beyond Last Shift Of BreakEndTime',
    breakStartTimeIsWrongBeyondWorkShiftTime: 'Of Break Start Time Is Wrong,Beyond Work Shift Time.Please Enter Again',
    breakEndTimeIsWrongBeyondWorkShiftTime: 'Of Break End Time Is Wrong,Beyond Work Shift Time.Please Enter Again',
    breakStartTimeIsWrong: 'Of Break Start Time Is Wrong.Please Enter Again',
    breakTimeGreaterThanWorkShiftTime: 'BreakTime Greater Than Work Shift Time,Please Check Again',
    lastShiftEndTime: 'Last Work Shift End Time:',
    nextShiftStartTime: 'Next Work Shift End Time:',
    workShiftStartTimeIllegal: ',Work Shift StartTime Illegal,Please Enter Again',
    workShiftEndTimeIllegal: ',Work Shift EndTime Illegal,Please Enter Again',
    wrongDate: 'Data is Wrong,Please Check Again',
    workShiftTimeIllegal: 'Work Shift Time Illegal,Please Enter Work Shift End Time Again'
  },
  PerGroup: {
    title: 'Team Management Page',
    groupId: 'Group Id',
    groupName: 'Group Name',
    ngroupId: 'Group Id can not be Empty',
    ngroupName: 'Group Name can not be Empty',
    pgroupId: 'Please Input Group Id',
    pgroupName: 'Please Input Group Name'

  },
  PerGroupUser: {
    title: 'Assign Team Members',
    userId: 'User Id',
    isThisGroup: 'Is This Group',
    assignuser: 'Assign User',
    assignsuccess: 'Assign Success',
    userName: 'User Name'
  },
  BaTechTightenPosition: {
    title: 'Job placement',
    upload: 'Whether to upload pictures',
    stepStyle: 'step style',
    stepStyleNotNull: 'step style can not be empty',
    deleteData: 'Delete the entire data',
    deleteData1: 'Confirm to delete the whole data?After deleting data, all corresponding pictures and work steps are deleted.',
    selectStepStyle: 'Please choose a step style',
    screwDown: 'screw down',
    pressFitting: 'press fitting',
    failSafe: 'fail safe',
    scan: 'scan',
    other: 'other',
    extend: 'Whether to extend',
    no: 'NO',
    yes: 'YES',
    extendId: 'extendId',
    enterExtendId: 'please enter a extendId',
    hideNumber: 'hide number',
    showNumber: 'show number',
    addPhotograph: 'Please add pictures before adding pictures for this model',
    pictureUploaded: 'Picture uploaded successfully',
    deletePicture: 'Confirm to delete the picture of the model?',
    noPicture: 'There are no pictures of this model',
    noPut: 'have not uploaded',
    yesPut: 'have already uploaded',
    insterStep: 'step style save successfully',
    updateExtend: 'extended operation',
    noExtend: 'No expansion for this model',
    isStep: 'One picture can store up to 50 steps',
    fileTypeError: 'Only Picture File Avaliable'
  },
  CraTechBom: {
    title: 'TechBom',
    copy: 'copy',
    delBoms: 'deletebatch',
    bomList: '物料列表',
    id: 'ID',
    factoryId: '工厂编号',
    lineId: '线体编号',
    opId: '工位号',
    platformId: '平台号',
    engineTypeLittle: '机种号',
    engineType: '机型号',
    assemblyCode: 'assembly code',
    assemblyName: 'assembly name',
    supplier: 'supplier',
    consumeQuantity: 'consume quantity',
    isScanning: 'isScanning',
    isMainMaterial: 'isMainMaterial',
    operateTime: 'operate time',
    export: 'export',
    import: 'import',
    importTips: 'Only XLSX files can be uploaded',
    scanning0: 'Not scan',
    scanning1: 'scan',
    mainMaterial0: 'Not mainMaterial',
    mainMaterial1: 'mainMaterial',
    toolbar: 'toolbar',
    temType: 'template',
    newType: 'newType',
    delType: 'Please select delete model',
    assemblyCodeValidate: 'assembly code is empty',
    assemblyNameValidate: 'assembly name is empty',
    consumeQuantityValidate: 'consume quantity empty',
    chooseFactoryLine: 'Please select the factory line',
    copySuccess: 'Copy success',
    importSucces: 'Import success',
    importFailed: 'Import failure',
    importTypeError: 'The import file format is incorrect',
    tableEmpty: 'The table is empty and cannot be exported',
    taskIdValidate: 'task id is empty',
    taskNameValidate: 'task name is empty',
    taskQuantity: 'task quantity is empty',
    chooseFile: 'Choose File',
    downtemp: 'download the template',
    no: 'NO.',
    importtitle: 'Bom Import',
    importFactoryTitle: 'Factory Bom Import',
    save: 'save',
    clear: 'clear',
    savesuccess: 'save success',
    importerr: 'error on IMPORT',
    clearSuccess: 'clear success',
    clearfailed: 'error on Clear',
    checkproblem: 'check problem',
    pleaceChooseFile: 'Please select a file first '
  },
  SysMenuSet: {
    systemMenu: 'System Menu',
    subSystemMenu: 'Subsystem menu',
    menuId: 'Menu ID',
    menuName: 'Menu Name',
    menuUrl: 'Menu Url',
    menuIcon: 'Menu Icon',
    menuParentId: 'Menu Parent ID',
    menuOrder: 'Menu Order',
    isLeaf: 'Is Leaf',
    menuIdCannotBeEmpty: 'Menu ID cannot be empty',
    MenNameCannotBeEmpty: 'Menu name cannot be empty',
    pleaseEnterTheMenuID: 'Please enter the menu ID',
    pleaseEnterTheMenuName: 'Please enter the menu name',
    pleaseEnterTheMenuParentID: 'Please enter the menu parent ID',
    pleaseEnterTheMenuOrder: 'Please enter the menu order',
    pleaseEnterTheisLeaf: 'Please enter whether the leaf node',
    pleaseEnterTheMenuUrl: 'Please enter the menu url'
  },
  CraTechFactoryBom: {
    title: 'FactoryBom',
    copy: '复制',
    delBoms: '批量删除',
    bomList: '物料列表',
    id: 'ID',
    factoryId: '工厂编号',
    lineId: '线体编号',
    taskId: 'taskId',
    taskName: 'taskName',
    taskQuantity: 'taskQuantity',
    opId: '工位号',
    platformId: '平台号',
    engineTypeLittle: '机种号',
    engineType: '机型号',
    assemblyCode: '组件编码',
    assemblyName: '组件描述',
    supplier: '供应商',
    consumeQuantity: '消耗数量',
    isScanning: '是否扫描',
    isMainMaterial: '是否主物料',
    operateTime: '操作时间'
  },
  BaTechStepDescription: {
    stepDescription: 'Step Description',
    descriptionnotNull: 'Step Description not be empty',
    deleteData: 'Are you sure？',
    title: 'Step Description Editer'
  },
  PerUser: {
    title: 'User Management Page',
    userId: 'User ID',
    userName: 'User Name',
    userPassword: 'User Password',
    userList: 'User List',
    searchId: 'Please Input UserID',
    searchName: 'Please Input UserName',
    searchDept: 'Please Select Dept',
    endpassword: 'Please Enter Your Password',
    makepassword: 'Please Confirm Your Password',
    userinfoplaceholder: 'Plaese Input Some User Infomation',
    role: 'Role',
    assignedstatus: 'Role Assign',
    checkuserid: 'Check UserID',
    resetpassword: 'Reset',
    checksuccess: 'This User ID IS Available',
    checkfail: 'This User ID IS NOT Available',
    useridlengthplaceholder: 'Length Need To Be Between 4 And 10 Characters',
    usernamelengthplaceholder: 'Length Need To Be Between 5 And 20 Characters',
    assignlistselectplaceholder: 'Please Select At Least One Role For Current User',
    makeSurePassword: 'Make Sure Password',
    postionId: 'Data Permissions',
    department: 'Department',
    chooseRole: 'Access Permission',
    chooseUserIcon: 'import user icon',
    choose: 'Please Choose',
    user: 'User',
    person: 'Person',
    isUser: 'Is User',
    inconsistentPasswords: 'Two Inconsistencies In Password Input',
    assignedStatusSuccess: 'Successful Role Assignment',
    assignedStatusFail: 'Failure In Role Assignment'
  },
  PerRole: {
    title: 'Role Management Page',
    roleId: 'Role Id',
    roleName: 'Role Name',
    roleDesc: 'Role Desc',
    searchCode: 'Please Input RoleCode',
    searchName: 'Please Input RoleName',
    searchDesc: 'Please Input RoleDesc',
    roleinfoplaceholder: 'Plaese Input Some Role Infomation',
    authority: 'Authority',
    assignedstatus: 'Authority Assign',
    authoritycode: 'Authority Code',
    authorityname: 'Authority Name',
    isrelatemenu: 'Relate To',
    authoritysearch: 'Please Input Authority Infomation',
    resourcename: 'Authority Resource',
    checkroleid: 'Check Role ID',
    checksuccess: 'This Role ID IS Available',
    checkfail: 'This Role ID IS NOT Available',
    roleidlengthplaceholder: 'Length Need To Be Between 5 And 10 Characters',
    rolenamelengthplaceholder: 'Length Need To Be Between 5 And 20 Characters',
    assignlistselectplaceholder: 'Please Select At Least One Authority For Current Role'
  },
  PerStruture: {
    title: 'Dept Management Page',
    deptName: 'Dept Name',
    deptDesc: 'Dept Desc',
    deptParentName: 'Parent Dept',
    deptNamePlaceholder: 'Plaese Input Dept Name',
    deptDescPlaceholder: 'Plaese Input Dept Desc',
    deptNamelengthplaceholder: 'Length Need To Be Between 1 And 50 Characters',
    deptDesclengthplaceholder: 'Length Need To Be Between 1 And 50 Characters',
    deptNameNotNull: 'Dept Name Is Not Null',
    deptDescNotNull: 'Dept Desc Is Not Null',
    rootSector: 'Root Sector'
  },
  QuaRepDataBarcode: {
    timeValueWarningMessage: 'please enter time query conditions ',
    lineIdWarningMessage: 'please enter lineId query conditions',
    placeholderStart: 'start time ',
    rangeSeparatoe: 'to',
    placeholderEnd: 'end time ',
    factoryId: 'factory number',
    factoryName: 'factoryName ',
    lineId: 'body number ',
    lineName: 'line body name ',
    opName: 'station name ',
    placeholderFactoryId: 'please enter factory name ',
    placeholderLineId: 'please enter line body name ',
    placeholderOpId: 'please enter station name ',
    placeholderEngineType: 'please enter the engine type ',
    placeholderEngineTypeLittle: 'please enter the model number',
    placeholderPlatformId: 'please enter the platform number ',
    placeholderTagValue: 'please enter the actual code',
    placeholderProductIdEnd: 'please enter the end of product id',
    placeholderProductIdStart: 'please enter the start of product id',
    isMainMaterial: 'is the main material',
    mainMaterial: 'MainMaterial',
    pickerOptionsShortcutsText1: 'in the latest week',
    pickerOptionsShortcutsText2: 'the last month',
    pickerOptionsShortcutsText3: 'in the past three months',
    title: 'Batch quality information',
    titlein: 'Batch quality details',
    timeStart: 'Select start date',
    timeEnd: 'Select end date',
    operateTime: 'Operate Time',
    tagValue: 'Tag Value',
    conditionShow: 'Search',
    platformId: 'platformId',
    engineTypeLittle: 'ProductType ID',
    engineType: 'Engine model',
    productId: 'Product Id',
    subProductId: 'Sub Product Id',
    productIdStart: 'Product Id Start',
    productIdEnd: 'Product Id End',
    decisionvalue: 'Decisionvalue',
    opId: 'Op Id',
    pengineTypeLittle: 'Please Input ProductType ID',
    pengineType: 'Please Input Engine model',
    pproductIdStart: 'Please Input Product Id Start',
    pproductIdEnd: 'Please Input Product Id End',
    popId: 'Please Input Op Id',
    particular: 'Particular',
    operation: 'Operation',
    Qualitydetails: 'Qualitydetails',
    assemblyCode: 'assemblyCode',
    assemblyName: 'assemblyName'
  },
  QmProdQualityDataWork: {
    date: 'Date',
    unlimitedDate: 'Unlimited Date',
    exportExcel: 'Export Excel',
    searchQualitydate: 'Search Quality Data',
    startTime: 'Start Time',
    endTime: 'End Time',
    chooseStartTime: 'Choose Start Time',
    chooseEndTime: 'Choose End Time',
    advancedQuery: 'Advanced Query',
    productId: 'Product ID',
    engineType: 'Engine Type',
    opId: 'OP ID',
    engineTypeLittle: 'Engine Type Little',
    lineId: 'Line ID',
    searchProductId: 'Please Input ProductId',
    searchProductIdStart: 'Please Input Start ProductId',
    searchProductIdEnd: 'Please Input End ProductId',
    searchEngineType: 'Please Input EngineType',
    searchOpId: 'Please Input OpId',
    searchEngineTypeLittle: 'Please Input EngineTypeLittle',
    searchLineId: 'Please Input LineId',
    orderNum: 'Order Num',
    shiftCode: 'Shift Code',
    trayNumber: 'Tray Number',
    platformId: 'Platform ID',
    tagValue: 'Tag Value',
    isOk: 'IS OK',
    searchIsOk: 'Search IS OK',
    isGoodbad: 'IS Goodbad',
    measureUnit: 'Meastre Unit',
    expectedValue: 'Expected Value',
    upperlimitValue: 'Upper Limit Value',
    lowerlimitValue: 'Lower Limit Value',
    columnPostion: 'Column Postion',
    columnSort: 'Column Sort',
    operateTime: 'Operate Time'
  },
  operation: {
    title: 'Operation Position Management Page',
    searchId: 'Please Input OP ID',
    searchName: 'Please Input OP Name',
    proceduceid: 'Proceduce ID',
    optypename: 'OP Type Name',
    orderselectname: 'Order Select',
    isserverinteractionname: 'Server Interaction',
    messageserverurl: 'Message Server URL',
    opcpartitionid: 'OPC Server URL',
    opcclientid: 'OPC Client ID',
    opidipaddress: 'OP IP Address',
    proceduceidplaceholder: 'Please Input ProceduceID',
    optypenameplaceholder: 'Please Select OP Type',
    messageserverurlplaceholder: 'Please Input Message Server URL',
    opcpartitionidplaceholder: 'Please Input OPC Server URL',
    opcclientidplaceholder: 'Please Input OPC ClientID',
    opidipaddressplaceholder: 'Please Input OP IP',
    opcclientidtypeholder: 'Please Input A Number',
    urlplaceholder: 'URL Illegal',
    ipplaceholder: 'IP Illegal',
    checkopid: 'Check OP ID',
    checksuccess: 'This OPID ID IS Available',
    checkfail: 'This OPID ID IS NOT Available',
    opidlengthplaceholder: 'Length Need To Be Between 5 And 10 Characters',
    opnamelengthplaceholder: 'Length Need To Be Less Than 50 Characters',
    lengthplaceholder: 'TOO LONG'
  },
  product: {
    buttonColumn: 'operation ',
    buttonDisable: 'disable ',
    buttonEnable: 'enable ',
    buttonSelect: 'query ',
    buttonCreate: 'new ',
    buttonUpdate: 'modify ',
    buttonDelete: 'delete ',
    buttonSubmit: 'confirm ',
    buttonCancel: 'cancel ',
    isDisable: 'disable or not ',
    factoryId: 'factory number',
    lineId: 'body number ',
    productModel: 'productModel',
    platformid: 'platform number ',
    engineTypeLittle: 'engine number',
    version: 'version number ',
    remark: 'Remark',
    placeholderFactoryId: 'please enter factory number ',
    placeholderLineId: 'please enter line body number ',
    placeholderProductModel: 'please enter product model number ',
    placeholderPlatformId: 'please enter platform number ',
    placeholderEngineTypeLittle: 'please enter the model number',
    placeholderRemark: 'please enter remark ',
    confirmtextTitle: 'confirmtextTitle',
    confirmtext: 'confirm to submit data?',
    ConfirmtextCancel: 'cancel ',
    warningMsg: 'please select the action line ',
    title: 'Product Management Page',
    searchmodel: 'Please Input Product Model',
    searchname: 'Please Input Product Model Name',
    ismainline: 'IS Main Line',
    productlengthplaceholder: 'Input Content IS Too Long',
    checkproductmodel: 'Check Product Model',
    checksuccess: 'This Product Model IS Available',
    checkfail: 'This Product Model IS NOT Available',
    platformId: 'platform id'
  },
  QuaRepDataModel: {
    timeValueWarningMessage: 'please enter time search message',
    engineTypeWarningMessage: 'please enter model number search message',
    title: 'type quality data query ',
    placeholderStart: 'start time ',
    rangeSeparatoe: 'to',
    placeholderEnd: 'end time ',
    placeholderFactoryId: 'please enter factory number ',
    placeholderLineId: 'please enter line body number ',
    placeholderOpId: 'please enter work station number ',
    placeholderPlatformId: 'please enter platform number ',
    placeholderProductId: 'please enter serial number ',
    placeholderEngineType: 'please enter engine type ',
    placeholderEngineTypeLittle: 'please enter the model number',
    placeholderOpName: 'please enter the op name',
    buttonColumn: 'operation ',
    buttonSelect: 'query ',
    buttonSubmit: 'confirm ',
    buttonCancel: 'cancel ',
    id: 'primary key id ',
    factoryId: 'factory number',
    lineId: 'body number ',
    productId: 'serial number ',
    tagId: 'tagId',
    orderNum: 'plan number ',
    shiftCode: 'shiftCode ',
    trayNumber: 'trayNumber',
    platformId: 'platform number ',
    platformName: 'TM model number ',
    engineType: 'model number ',
    engineTypeLittle: 'engine number',
    tagValue: 'measured value ',
    isOk: 'general conformity mark ',
    isGoodbad: 'mark of conformity ',
    measureUnit: 'measureUnit',
    measurepPosition: 'measurepPosition',
    measureItem: 'measureItem',
    opId: 'station number ',
    opName: 'station Name ',
    expectedValue: 'theoretical value ',
    upperlimitValue: 'upperlimitValue ',
    lowerlimitValue: 'lowerlimitValue ',
    columnPostion: 'columnposition ',
    columnSort: 'sort in a column ',
    operateTime: 'operateTime ',
    isDisabled: 'isDisabled ',
    version: 'version number ',
    dialogTitle: 'details ',
    pickerOptionsShortcutsText1: 'in the latest week',
    pickerOptionsShortcutsText2: 'the last month',
    pickerOptionsShortcutsText3: 'in the last three months',
    fileContents: 'file contents'
  },
  AnTechBasicdata: {
    title: 'installation lamp configuration management ',
    buttonCreate: 'new ',
    buttonDelete: 'delete ',
    buttonUpdate: 'edit ',
    placeholderFactoryId: 'please enter factory number ',
    placeholderLineId: 'please enter line body number ',
    placeholderOpName: 'please enter position number ',
    placeholderAnCode: 'please enter the placeholderAnCode ',
    placeholderAnContent: 'please enter the type description ',
    placeholderColor: 'please enter color ',
    id: 'primary key id ',
    factoryId: 'factory number',
    lineId: 'body number ',
    opName: 'station number ',
    opStation: 'station name',
    anCode: 'lamp type code ',
    anCodeDescription: 'lamp type description ',
    anContent: 'description of lamp type ',
    color: 'the color',
    isDisabled: 'isDisabled ',
    version: 'version number ',
    confirmtextTitle: 'confirmtextTitle',
    confirmtext: 'confirm to submit data?',
    confirmtextCancel: 'cancel ',
    warningMsg: 'please select action line'
  },
  AnTechHistoryData: {
    timeValueWarningMessage: 'please enter time search message',
    title: 'information query of lamp installation ',
    placeholderStart: 'relieve start time ',
    rangeSeparatoe: 'to',
    placeholderEnd: 'relieve end time ',
    placeholderFactoryId: 'please enter factory number ',
    placeholderLineId: 'please enter line body number ',
    placeholderOpId: 'please enter work station number ',
    placeholderAnCode: 'please enter the placeholderAnCode ',
    opId: 'station number ',
    opName: 'station Name',
    anCode: 'lamp type code ',
    anCodeType: 'lamp type name',
    anCodeDescription: 'lamp type description ',
    anContent: 'anContent',
    productId: 'serial number ',
    orderNum: 'plan number ',
    platformId: 'platform number ',
    engineType: 'model number ',
    engineTypeLittle: 'engine number',
    factoryId: 'factory number',
    lineId: 'body number ',
    orderNumber: 'orderNumber',
    callUserId: 'caller ID',
    callUserName: 'caller name ',
    callInTime: 'call time ',
    callOutTime: 'lift time',
    pickerOptionsShortcutsText1: 'in the latest week',
    pickerOptionsShortcutsText2: 'the last month',
    pickerOptionsShortcutsText3: 'in the last three months'
  },
  QuaRepDataWorkNew: {
    timeValueWarningMessage: 'please enter time search message',
    opIdWarningMessage: 'please enter opstation search message',
    title: 'Process quality data query ',
    placeholderStart: 'start time ',
    rangeSeparatoe: 'to',
    placeholderEnd: 'end time ',
    placeholderFactoryId: 'please enter factory number ',
    placeholderLineId: 'please enter line body number ',
    placeholderOpId: 'please enter work station number ',
    placeholderPlatformId: 'please enter platform number ',
    placeholderProductId: 'please enter serial number ',
    placeholderEngineType: 'please input type number ',
    placeholderEngineTypeLittle: 'please enter the model number',
    placeholderOpName: 'please enter the op name',
    buttonColumn: 'operation ',
    buttonSelect: 'query ',
    buttonSubmit: 'confirm ',
    buttonCancel: 'cancel ',
    id: 'primary key id ',
    factoryId: 'factory number',
    lineId: 'body number ',
    productId: 'serial number ',
    tagId: 'tagId',
    orderNum: 'plan number ',
    shiftCode: 'shiftCode ',
    trayNumber: 'trayNumber',
    platformId: 'platform number ',
    platformName: 'TM model number ',
    engineType: 'model number ',
    engineTypeLittle: 'engine number',
    tagValue: 'measured value ',
    isOk: 'general conformity mark ',
    isGoodbad: 'mark of conformity ',
    measureUnit: 'measureUnit',
    measurepPosition: 'measurepPosition',
    measureItem: 'measureItem',
    opId: 'station number ',
    opName: 'station Name ',
    expectedValue: 'theoretical value ',
    upperlimitValue: 'upperlimitValue ',
    lowerlimitValue: 'lowerlimitValue ',
    columnPostion: 'columnposition ',
    columnSort: 'sort in a column ',
    operateTime: 'operateTime ',
    isDisabled: 'isDisabled ',
    version: 'version number ',
    dialogTitle: 'details ',
    pickerOptionsShortcutsText1: 'in the latest week',
    pickerOptionsShortcutsText2: 'the last month',
    pickerOptionsShortcutsText3: 'in the last three months'
  },
  MacMachStation: {
    title: 'Station configuration',
    treeTitle: 'Factory build',
    infactoryId: 'Factory ID',
    inlineId: 'Line ID',
    inopId: 'Op Id',
    inopName: 'Op Name',
    opName: 'Op Name',
    save: 'Save',
    nosave: 'No Save',
    HavePrinter: 'Yes',
    noHavePrinter: 'No',
    CannotSelectOrder: 'Cannot Select Order Permissions',
    CanSelectOrder: 'Can Select Order Permissions',
    orderSelectIdSel: 'Choose the Order Permissions',
    porderSelectIdSel: 'Please Choose the Order Permissions',
    plcIp: 'PLC-IP Address',
    pplcIp: 'Please Input PLC-IP Address',
    ipcIp: 'IPC-IP Address',
    pipcIp: 'Please Input IPC-IP Address',
    opNameNotNull: 'Op Name cannot be empty',
    produceNum: 'Process number cannot be empty',
    PLCIPNotNull: 'PLC-IP Address cannot be empty',
    IPCIPNotNull: 'IPC-IP Address cannot be empty',
    OnlineStation: 'Online Station',
    OnlineRepairStation: 'Online Repair Station',
    GeneralStation: 'General Station',
    RepairUaLWorkStation: 'Repair UaLwork Station',
    IsQualifiedOfflineStation: 'IsQualified Offline Station',
    QualifiedOfflineStation: 'Qualified Offline Station',
    UnqualifiedOfflineStation: 'Unqualified Offline Station',
    pmonitoringPropertyCode: 'Please Input MonitoringPropertyCode',
    isHavePrinter: 'Is Have Printer',
    popTypeId: 'Please Input Location type',
    isMesEnabled: 'Is Mes Enabled',
    orderselectname: 'Order Select'
  },
  MacRawData: {
    title: 'Raw Data Configuration',
    placeholderFactoryId: 'Please Input Factory Id',
    placeholderLineId: 'Please Input Line Id',
    placeholderOpId: 'Please Input OP Id',
    placeholderFactoryName: 'please enter factory name',
    placeholderLineName: 'please enter line name',
    placeholderOpName: 'please enter op name',
    column: 'operation',
    search: 'search',
    create: 'create',
    modify: 'modify',
    delete: 'delete',
    sure: 'sure',
    cancel: 'cancel',
    factoryId: 'Factory name',
    lineId: 'Line name',
    tagId: 'tagId',
    opId: 'OP name',
    dataSources: 'Data Sources',
    plcip: 'PLC IP',
    tagTypeId: 'tag Type Id',
    tagLong: 'tag Long',
    dbName: 'DB Name',
    tagType: 'tag Type',
    variableAddress: 'Variable Address',
    variableOthers: 'Variable Others',
    columnPosition: 'Column Position',
    measuringPosition: 'Measuring Position',
    measuringItems: 'Measuring Items',
    measuringUnit: 'Measuring Unit',
    variableTypeCode: 'Variable Type Code',
    variableTypeName: 'Variable Type Name',
    tagAdr: 'tag Adr',
    isEnabled: 'Is Enabled',
    variableCharacteristics: 'Variable Characteristics',
    variableSort: 'Variable Sort',
    monitoringPropertyCode: 'Monitoring PropertyCode',
    quality: 'Is Quality Data',
    yes: 'yes',
    no: 'no',
    placeholdertagId: 'Please Input tagId',
    placeholderdataSources: 'Please Input dataSources',
    placeholderplcip: 'Please Input plc ip',
    placeholdertagTypeId: 'Please Input tagTypeId',
    placeholdertagLong: 'Please Input tagLong',
    placeholderdbName: 'Please Input dbName',
    placeholdertagType: 'Please Input tagType',
    placeholdervariableAddress: 'Please Input variableAddress',
    placeholdervariableOthers: 'Please Input variableOthers',
    placeholdercolumnPosition: 'Please Input columnPosition',
    placeholdermeasuringPosition: 'Please Input measuringPosition',
    placeholdermeasuringItems: 'Please Input measuringItems',
    placeholdermeasuringUnit: 'Please Input measuringUnit',
    placeholdervariableTypeCode: 'Please Input variableTypeCode',
    placeholdervariableTypeName: 'Please Input variableTypeName',
    placeholdertagAdr: 'Please Input tagAdr',
    placeholdervariableCharacteristics: 'Please Input variableCharacteristics',
    placeholdervariableSort: 'Please Input variableSort',
    placeholdermonitoringPropertyCode: 'Please Input monitoringPropertyCode',
    rulelength50: 'The length cannot exceed 50',
    rulelength20: 'The length cannot exceed 20',
    rulelength12: 'The length cannot exceed 12',
    checktagid: 'checktagid',
    checkfail: 'The tagid has occupied',
    checksuccess: 'The tagid available',
    searchCode: 'Please enter the tagid',
    rulenumber: 'Please enter a numeric value',
    ruletagIdnull: 'tagId can not be empty',
    rulefactoryIdnull: 'factoryId can not be empty',
    rulelineIdnull: 'lineId can not be empty',
    ruleopIdnull: 'opId can not be empty',
    ruledataSourcesnull: 'dataSourcescan not be empty',
    ruleipPlcnull: 'plc ip can not be empty',
    ruletagTypeIdnull: 'tagTypeId can not be empty',
    ruletagLongnull: 'tagLong can not be empty',
    ruledbNamenull: 'dbName can not be empty',
    ruletagTypenull: 'tagType can not be empty',
    rulevariableAddressnull: 'variableAddress can not be empty',
    rulevariableOthersnull: 'variableOthers format is not correct',
    rulecolumnPositionnull: 'columnPosition can not be empty',
    rulemeasuringPositionnull: 'measuringPosition can not be empty',
    rulemeasuringItemsnull: 'measuringItems can not be empty',
    rulemeasuringUnitnull: 'measuringUnit can not be empty',
    rulevariableTypeCodenull: 'variableTypeCode can not be empty',
    rulevariableTypeNamenull: 'variableTypeName can not be empty',
    ruletagAdrnull: 'tagAdr can not be empty',
    rulevariableCharacteristicsnull: 'variableCharacteristics can not be empty',
    rulevariableSortnull: 'variableSort can not be empty',
    rulemonitoringPropertyCodenull: 'monitoringPropertyCode can not be empty',
    deleteDialog: 'This will permanently delete this data, whether to continue?',
    baseBeatnull: 'Base beat cannot be empty',
    maxLength5: 'Please Input A Number 0~99999 Digits',
    baseBeat: 'Base Beat' //
  },
  QuaRepQuality: {
    title: 'Tech Quality',
    placeholderFactoryId: 'Please Input Factory Name',
    placeholderLineId: 'Please Input Line Name',
    placeholderOpId: 'Please Input OP Name',
    placeholderFactoryName: 'please enter factory name',
    placeholderLineName: 'please enter line name',
    placeholderOpName: 'please enter op name',
    placeholderEngineType: 'Please Input EngineType',
    placeholderEngineTypeLittle: 'Please Input EngineType-Little',
    placeholderPlatformId: 'Please Input PlatformId',
    column: 'operation',
    search: 'search',
    create: 'create',
    modify: 'modify',
    delete: 'delete',
    sure: 'sure',
    cancel: 'cancel',
    Id: 'id',
    factoryId: 'Factory name',
    lineId: 'Line name',
    tagId: 'Raw Data tagId',
    opId: 'OP name',
    engineType: 'Engine Type',
    engineTypeLittle: 'Engine Type Little',
    platformId: 'Platform Id',
    upperlimitValue: 'Upper Limit Value',
    lowerlimitValue: 'Lower Limit Value',
    expectedValue: 'Expected Value',
    flagId: 'Flag Id',
    updateUserName: 'Update UserName',
    updateDate: 'Update Date',
    version: 'Version',
    isEnabled: 'Is Enabled',
    yes: 'yes',
    no: 'no',
    conditionShow: 'searchmore',
    searchtemplate: 'please select the template',
    rulelength50: 'The length cannot exceed 50',
    rulelength12: 'The length cannot exceed 12',
    rulenumber: 'Please enter a numeric value'
  },
  SysWorkCalendar: {
    title: 'Work calendar',
    factoryName: 'FactoryName',
    lineName: 'LineName',
    placeholderFactoryName: 'Please Input Factory Name',
    placeholderLineId: 'Please Input Line Name',
    year: 'year',
    month: 'month',
    checkdata: 'Select date',
    selectYear: 'Select year',
    selectMonth: 'Select month',
    rest: 'Holiday',
    holiday: 'Holiday',
    holidayDate: 'Holiday date',
    setHoliday: 'This operation permanently set the date to holiday. Do you want to continue?',
    setSuccess: 'Set success',
    set: 'set',
    cancelSet: 'Cancel set'
  },
  SysWorkCalendarTips: {
    title: 'Work calendar tips',
    userId: 'User id',
    userName: 'User name',
    mailAdr: 'Mail adress',
    mailDetails: 'Mail details',
    isEnabled: 'Is enabled',
    sendDatetime: 'Send mail time',
    ruleuserNamenull: 'Username can not be empty',
    rulemailAdrnull: 'Mailadr can not be empty',
    rulemailDetailsnull: 'Mail details can not be empty',
    rulesendDatetimenull: 'Send datetime can not be empty',
    rulemailTypesnull: 'Mail Type can not be empty',
    rulemailTitlesnull: 'Mail Title can not be empty',
    rulemailParticularsnull: 'Mail Particulars can not be empty',
    rulelength20: 'The length cannot exceed 20',
    rulelength50: 'The length cannot exceed 50',
    rulelength100: 'The length cannot exceed 100',
    placeholderUserName: 'Please Input user name',
    placeholderMailAdr: 'Please Input mail address',
    placeholderMailDetails: 'Please Input mail details',
    placeholderSendTime: 'Please Input send time',
    placeholderMailTitle: 'Please Input Mail Title',
    placeholderMailType: 'Please Input Mail Type',
    placeholderMailParticular: 'Please Input Mail Particular',
    changeStatesSuccess: 'Update States Success',
    changeStatesFailure: 'Update States Failure'
  },
  PerUserMail: {
    title: 'Per User Mail',
    id: 'id',
    userId: 'userId',
    userName: 'userName',
    deptName: 'deptName',
    deptId: 'deptId',
    mailAdr: 'mailAdr',
    isEnabled: 'isEnabled',
    rulenumber: 'Please enter a numeric value',
    rulelength50: 'The length cannot exceed 50',
    rulelength20: 'The length cannot exceed 20',
    rulenull: 'Content cannot be empty',
    ruledeptIdnull: 'Deptid can not be empty',
    ruledeptNamenull: 'Deptname can not be empty',
    ruleuserIdnull: 'Userid can not be empty',
    ruleuserNamenull: 'Username can not be empty',
    rulemailAdrnull: 'Mailadr can not be empty',
    rulemailAdr: 'Mailadr format is not correct',
    placeholderDeptId: 'Please input Dept ID',
    placeholderDeptName: 'Please input Dept name',
    placeholderUserName: 'Please input user name',
    placeholderMailAdr: 'Please input mail address'
  },
  PerCron: {
    title: 'Cron',
    isEnabled: 'isEnabled',
    cronName: 'Cron name',
    cronValue: 'Cron value',
    placeholdercronName: 'Please input Cron name',
    placeholdercronValue: 'Please input Cron value',
    rulelength50: 'The length cannot exceed 50',
    rulelength100: 'The length cannot exceed 100'
  },
  workshift: {
    title: 'Work Shift Management Page',
    workshiftid: 'Work Shift ID',
    workshiftname: 'Work Shift Name',
    searchid: 'Please Input Work Shift ID',
    searchname: 'Please Input Work Shift Name',
    workshiftstarttime: 'Work Shift Start Time',
    workshiftendtime: 'Work Shift End Time',
    forbiddenname: 'Forbidden',
    checktimefail: 'Please Double Check The Time',
    checkforbiddenfail: 'At Least Enable One Work Shift',
    attention1: '1.The Start And End Time Of Every Enabled Work Shift Must Not Have A Cross',
    attention2: '2.At Least One Work Shift Has To Be Enabled'
  },
  program: {
    title: 'Program Management Page',
    buttonSelect: 'query ',
    buttonCreate: 'new ',
    buttonUpdate: 'modify ',
    buttonDelete: 'delete ',
    buttonSubmit: 'confirm ',
    buttonCancel: 'cancel ',
    placeholderLineId: 'please enter line body number ',
    placeholderFactoryId: 'please enter factory number ',
    placeholderOpStation: 'please enter station number ',
    placeholderProgramNum: 'please enter program number ',
    factoryId: 'factory number',
    lineId: 'body number ',
    opStation: 'opId',
    opName: 'opName',
    programId: 'programId',
    programNum: 'program number',
    version: 'version number ',
    confirmtextTitle: 'confirmtextTitle',
    confirmtext: 'confirm to submit data?',
    confirmtextCancel: 'cancel ',
    warningMsg: 'please select the action line ',
    searchid: 'Please Input Program ID',
    searchname: 'Please Input Program Name',
    assignedstatus: 'Step Assign Status',
    checkid: 'Check Program ID',
    checksuccess: 'This Program ID IS Available',
    checkfail: 'This Program ID IS NOT Available',
    notrelate: 'Relate To Position',
    relate: 'Relate To Program',
    caution: 'Automatically Filtration Steps NOT Relate To Program',
    programIdplaceholder: 'Please Input A Number Between 0 And 99',
    placeholderPlatformId: 'please enter the platform ID',
    placeholderOpName: 'please enter the op name',
    placeholderEngineType: 'please enter the engine type',
    placeholderEngineTypeLittle: 'please enter the engine type little',
    placeholderProductId: 'please enter the product id',
    placeholderProduceNum: 'please enter the produce number',
    produceNum: 'produce number'
  },
  programconfig: {
    title: 'ProgramConfig Management Page',
    configprogram: 'Config Program',
    buttonSelect: 'query ',
    buttonCreate: 'new ',
    buttonUpdate: 'modify ',
    buttonDelete: 'delete ',
    buttonSubmit: 'confirm ',
    buttonCancel: 'cancel ',
    confirmtextTitle: 'confirmtextTitle',
    confirmtext: 'confirm to submit data?',
    confirmtextCancel: 'cancel ',
    warningMsg: 'please select the action line ',
    placeholderFactoryId: 'please enter factory number ',
    placeholderLineId: 'please enter line body number ',
    placeholderOpId: 'please enter work station number ',
    placeholderProgramNum: 'please enter program number ',
    placeholderEngineType: 'please input type number ',
    factoryId: 'factory number',
    engineType: 'model number ',
    lineId: 'body number ',
    opId: 'station number ',
    opName: 'station Name',
    programNum: 'program number',
    version: 'version number ',
    searchid: 'Please Input OP ID',
    searchname: 'Please Input Product Model',
    programIdplaceholder: 'Please Select ProgramID'
  },
  action: {
    title: 'Action Management Page',
    searchid: 'Please Input Action ID',
    searchname: 'Please Input Action Name',
    steprespond: 'Step Respond Target',
    isrepareselectaction: 'Repare Select Action',
    isallowactionredo: 'Action Redo',
    actionunit: 'Action Unit',
    actionextremumvalue: 'Action Extremum',
    sleeveid: 'Sleeve ID',
    actioncomponentid: 'Action Component ID',
    issavedata: 'Save Data',
    stepRespondIdplaceholder: 'Please Select Step Respond Target',
    actionunitplaceholder: 'Please Select Action Unit',
    minholder: 'Please Input Minimum Value',
    maxholder: 'Please Input Maximal Value',
    sleeveidplaceholder: 'Please Input Sleeve ID',
    actioncomponentidplaceholder: 'Please Input Action Component ID',
    numberholder: 'Please Input A Number Less-Than 99',
    checkid: 'Check Action ID',
    checksuccess: 'This Action ID IS Available',
    checkfail: 'This Action ID IS NOT Available'
  },
  step: {
    searchopid: 'Please Input OPID',
    searchid: 'Please Input Step ID',
    searchname: 'Please Input Step Name',
    steppicture: 'Step Icon',
    stepurl: 'Step Picture',
    isrelatetoprogram: 'Program Relativity',
    isrepareselectstep: 'Repare Select Step',
    forbidden: 'Forbidden',
    assignedstatus: 'Action Assign Status',
    numberholder: 'Please Input A Number',
    lengthplaceholder: 'Length Need To Be Less Than 20 Characters',
    actionassignplaceholder: 'At Least Select One Action',
    stepurlplaceholder: 'Please Input Step Picture URL',
    checkid: 'Check Step ID',
    checksuccess: 'This Step ID IS Available',
    checkfail: 'This Step ID IS NOT Available'
  },
  plan: {
    title: 'Order Management',
    planfrom: 'Plan From',
    searchid: 'Please Input ERP Order Number',
    searchname: 'Please Select Order Status',
    searchenginetypelittle: 'Please Select Enginetypelittle',
    searchenginetype: 'Please Select Enginetype',
    ordercount: 'Order Count',
    planstarttime: 'Plan Start Time',
    planendtime: 'Plan End Time',
    actualstarttime: 'Actual Start Time',
    actualendtime: 'Actual End Time',
    datemark: 'To',
    schedulingornot: 'Scheduling Or Not',
    plandate: 'Plan Start Date',
    ordersequence: 'Order Sequence',
    ordersourcename: 'Order Source',
    orderstatusname: 'Order Status',
    repairordername: 'Repair Order',
    ordercountplaceholder: 'Please Input Order Count',
    ordersequenceplaceholder: 'Please Input Order Sequence',
    orderstatusnameplaceholder: 'Please Select Order Status',
    plandateplaceholder: 'Please Select Plan Date',
    lengthplaceholder: 'Input Content Is Too Long',
    numberplaceholder: 'Please Input Number',
    checkid: 'Check Order ID',
    checksuccess: 'This Order ID IS Available',
    checkfail: 'This Order ID IS NOT Available',
    selectplatformid: 'Please Select Plan From ID',
    selectlineid: 'Please Select Line ID',
    selectfactoryid: 'Please Select Factory ID',
    sortdown: 'Order ordering goes down',
    orderissued: 'Successful assignment',
    orderfreeze: 'Task freezing successful',
    orderclose: 'Task shutdown successful',
    insertPlan: 'Is it a slip?',
    searchinsertPlan: 'Please choose whether to insert the bill or not'
  },
  planreceive: {
    title: 'Order Receive',
    ordername: 'ERP Order Name',
    ordernumber: 'ERP Order Number',
    assemblyNum: 'ERP Order Type',
    startdata: 'ERP Order StartDate'

  },
  MacEquipmentPlan: {
    title: 'Equipment Maintenance Plan',
    maintainId: 'Maintenance Plan Number',
    maintainIdenter: 'Please Input Maintenance Plan Number',
    datestart: 'Maintenance Start Time',
    dateend: 'Maintenance End Time',
    maintenancetime: 'Maintenance Time ',
    maintainperiodenter: 'Please Choose Maintenance Generation Period',
    maintainperiod: 'Maintenance Generation Period'
  },
  MacEquipmentOverhaul: {
    title: 'Equipment Maintenance Information Query',
    maintenanceplannumber: 'Maintenance Plan Number',
    maintainernumber: 'Maintainer Number',
    maintainername: 'Maintainer Name',
    maintainernamePlaceholder: 'Please Input The Name Of The Maintainer',
    lasttime: 'Last Generation Time'
  },
  serialnumber: {
    title: 'Serial Number Management Page',
    isgenerateproductmodel: 'Generate By Product Model',
    generatetype: 'Generate Type',
    reserve: 'Reserve'
  },
  subproduct: {
    title: 'Online Match Management Page',
    subproductmodel: 'Sub Product Model',
    mainline: 'Main Line',
    selecterror: 'Please Select Different Product To Match'
  },
  langselect: {
    switchsuccess: 'Switch Language Success',
    switchfail: 'Switch Language Fail'
  },
  info: {
    selecterp: 'Input ERP Order Number'
  },
  timeshow: {
    weekarray: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ],
    titleformat: '{y}-{m}-{d} {a} {h}:{i}:{s}'
  },
  namenu: {
    menutitle: 'Menu'
  },
  hstitle: {
    logout: 'logout'
  },
  page404: {
    homepage: 'back home',
    describe: 'Data does not exist or does not have access!'
  },
  home: {
    title: 'production line status information ',
    buttontitle: 'inputButton',
    factoryId: 'factory number',
    lineId: 'body number ',
    produceDate: 'date of production ',
    shiftCode: 'shiftCode ',
    orderNum: 'ERP order number ',
    platformid: 'platform number ',
    engineTypeLittle: 'engine number',
    engineType: 'model number ',
    onlineCount: 'number of posts ',
    offlineCount: 'offline quantity ',
    okCount: 'qualified quantity ',
    ngCount: 'rejected quantity ',
    orderState: 'orderState',
    orderState0: 'already received',
    orderState1: 'released work',
    orderState2: 'on stream',
    orderState3: 'paused',
    orderState4: 'Have been frozen',
    orderState5: 'closed job'
  },
  MacOperationStationData: {
    timeValueWarningMessage: 'please enter time query conditions ',
    opIdWarningMessage: 'please enter station query conditions ',
    placeholderStart: 'operation start time ',
    rangeSeparatoe: 'to',
    placeholderEnd: 'operation end time ',
    pickerOptionsShortcutsText1: 'in the latest week',
    pickerOptionsShortcutsText2: 'the last month',
    pickerOptionsShortcutsText3: 'in the past three months',
    titleRepairParts: 'outgoing information of repaired parts ',
    titleCalibrationParts: 'calibration parts offsite information ',
    placeholderFactoryId: 'please enter factory name ',
    placeholderLineId: 'please enter line body name ',
    placeholderOpId: 'please enter station name ',
    id: 'id',
    factoryId: 'factory name ',
    lineId: 'body name ',
    opId: 'station number ',
    factoryName: 'factoryName ',
    lineName: 'line body name ',
    opName: 'station name ',
    productId: 'serial number ',
    orderNum: 'ERP order number ',
    shiftCode: 'shiftCode ',
    trayNumber: 'trayNumber',
    operatorId: 'operatorId',
    platformId: 'platform number ',
    engineType: 'model number ',
    engineTypeBig: 'engine number',
    standardCycleTime: 'standardCycleTime',
    actualCycleTime: 'actual time ',
    blockTime: 'blockTime ',
    freeTime: 'It is freeTime',
    inPlaceTime: 'workpiece inPlaceTime ',
    productState: 'artifact state ',
    okFlag: 'okFlag',
    isDisable: 'disable or not ',
    isFirstStop: 'stop first ',
    operateTime: 'operateTime ',
    version: 'version number',
    title: 'stop information display',
    isFirstStopY: 'FirstStop',
    isFirstStopN: 'NotFirstStop',
    FTTreport: 'FTT Report'
  },
  SysPostionFactoryLine: {
    dataPermissionCoding: 'Data Permission Coding',
    dataPermissionName: 'Data Permission Name',
    dataPermission: 'Data Permission',
    unselectedPosition: 'Unselected Position'
  },
  SysAuthorityCenter: {
    roleName: 'Role Name',
    characterRendering: 'Character Rendering',
    buttonPermissions: 'Button Permissions',
    unselectedRole: 'Unselected Role'
  },
  MacNumberStatus: {
    title: 'Production Information Display',
    numberstatus: 'Production Number Status',
    onlineTime: 'OnlineTime',
    offlineTime: 'OfflineTime',
    placeholdernumber: 'Please Enter Station Name',
    numberERP: 'Please enter a number in the ERP task number'
  },
  ErrorProofResults: {
    errorProofInformationQuery: 'Error Proof Information Query',
    factoryName: 'Factory Name',
    lineName: 'Line Name',
    productId: 'Product Id',
    opName: 'Op Name',
    shiftCode: 'Shift Code',
    trayNumber: 'Tray Number',
    platformId: 'Platform Id',
    engineTypeLittle: 'Engine Type Little',
    engineType: 'Engine Type',
    isOk: 'Is Ok',
    tagValue: 'Tag Value',
    measuringItems: 'Measuring Items',
    isDisabled: 'Is Disabled',
    operateTime: 'Operate Time',
    startUsing: 'Start Using',
    disable: 'Disable'
  },
  RtProductTime: {
    title: 'product time'
  },
  RtProductTakt: {
    title: 'product takt'
  },
  MacRtMTTR: {
    title: 'MTTR',
    yFormatter: '（time/number）'
  },
  MacRtMTBF: {
    title: 'MTBF',
    yFormatter: '（time/number）'
  },
  RtXBarR: {
    title: 'XBarR',
    yBarFormatter: '',
    yRFormatter: '',
    measureItem: 'measureItem data',
    measureItemPlaceholder: 'please choose measureItem data',
    measureItemNotNull: 'measureItem data is not null '
  },
  RtEquipmentFault: {
    title: 'EquipmentFault',
    yFormatter: ''
  },
  RtEquipmentMFault: {
    title: 'EquipmentMFault',
    yFormatter: ''
  },
  MacRepSpeedRate: {
    title: 'SpeedRate',
    yFormatter: ''
  },
  MacRepTimeRate: {
    title: 'TimeRate',
    yFormatter: ''
  },
  QuaRepProductionP: {
    title: 'P'
  },
  MacRepPerformanceRunRrate: {
    title: 'PerformanceRunRrate'
  },
  RtOee: {
    title: 'OEE'
  },
  RtOperatingTime: {
    title: 'OperatingTime'
  },
  RtLoadingTime: {
    title: 'LoadingTime'
  },
  RtRateEfficiency: {
    title: 'RateEfficiency'
  },
  ProRepEquipmentUptime: {
    title: 'RtEquipmentUptime'
  },
  ProRepJPH: {
    JPHSelect: 'JPH Query',
    yFormatter: 'Station / hour'
  },
  QuaRepMsa: {
    title: 'MSA'
  },
  MacPmProdOpMonitory: {
    title: 'Dynamic Monitoring',
    editMode: 'edit mode',
    returnView: 'return view',
    delete: 'delete',
    opModify: 'option modify',
    op: 'op',
    opWidth: 'width',
    opColor: 'color',
    pleaseChoice: 'please choice',
    moveSpeed: 'move speed',
    saveAll: 'save all',
    new: 'new',
    slow: 'slow',
    fast: 'fast',
    text1: 'Please choice move speed and click OP',
    text2: 'Use arrow key to set position',
    text3: 'Suggest to close left navigation bar'
  },
  MacFactoryLine: {
    title: 'line dictionary',
    title2: 'factory dictionary',
    title3: 'station dictionary',
    listTitle: 'factory list',
    factoryNamePlaceholder: 'Please input line',
    lineNamePlaceholder: 'Please input line',
    role: 'role',
    assignedstatus: 'role assigned',
    checkuserid: 'check userID',
    resetpassword: 'reset password',
    useridlengthplaceholder: 'Please input A number between 5 and 10',
    usernamelengthplaceholder: 'Please input A number fewer than 20',
    assignlistselectplaceholder: 'Please choise at least one role for current user'
  },
  CraTechRoute: {
    factoryId: 'factoryId',
    factoryName: 'factoryName',
    lineId: 'lineId',
    opId: 'opId',
    opName: 'opName',
    produceNum: 'produceNum',
    routeNum: 'routeNum',
    dialogTitle: 'RouteNumEditer',
    listSearchTitle: 'RouteNumConfiguration',
    routeNumNotNull: 'RouteNum Can Not Be Empty',
    routeNumPlaceholder: 'Please Enter RouteNum',
    digitlengthplaceholder10: 'Please enter a number within 10 digits',
    noStationInformation: 'No Station Information',
    stationPlaceholder: 'Please Drag Station Information Here',
    routeNumRepeat: 'RouteNum Repeat'
  },
  BaPerIndicatorLight: {
    title: 'HMI indicator configuration',
    factoryName: 'The factory name',
    lineName: 'Line body name',
    opName: 'Location name',
    placeholderFactoryName: 'Please enter the factory name',
    placeholderLineName: 'Please enter a line name',
    placeholderOpName: 'Please enter the station name',
    isEnabled: 'Whether to disable',
    search: 'The query',
    opname: 'Location name',
    opid: 'Location number',
    lightLabel: 'Name of indicator light',
    placeholderlightLabel: 'Please enter the name of the indicator light',
    create: 'new',
    cancel: 'cancel',
    sure: 'determine',
    modify: 'The edito',
    isDisable: 'Whether to disable',
    forbidden: 'enable',
    notforbidden: 'disable',
    all: 'all',
    operation: 'operation',
    delete: 'delete',
    updateSuccess: 'Modify the success',
    noResponseWarningMessage: 'No data meeting query criteria',
    deleteConfirm: 'This operation will permanently delete the data, whether to continue?',
    prompt: 'prompt',
    deleteSuccess: 'Delete the success',
    cancelDelete: 'Cancelled delete',
    newSuccess: 'New success',
    lightKey: 'Indicator light identification',
    placeholderlightKey: 'Please enter the indicator indicator!',
    factoryNamePlaceholder: 'Factory name cannot be empty!',
    lineNamePlaceholder: 'Line body name cannot be empty!'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js